<template>
  <form @submit.prevent="validateForm" class="confirm-user ine-form__form">
    <div class="ine-form__title-wrapper">
      <h4 class="ine-form__welcome">Confirm a User</h4>
      <p class="ine-form__lead-in">
        Please enter the users email address
      </p>
    </div>
    <div class="ine-form__form-group">
      <input
        @keyup="validateEmail()"
        type="email"
        class="ine-form__form-control"
        placeholder="email"
        v-model="email"
      />
    </div>
    <div class="ine-form__submit-btn-wrapper">
      <button
        v-show="!loading"
        class="ine-form__submit-btn btn__auth"
        type="submit"
      >
        Confirm User
        <span class="material-icons btn__auth--icon">person</span>
      </button>
      <ClipLoader v-show="loading" :size="1.5" sizeUnit="rem"></ClipLoader>
    </div>
    <div v-show="!loading" class="ine-form__additional-links-wrapper">
      <router-link class="ine-form__additional-link" :to="{ name: 'home' }"
        >Back to Homepage</router-link
      >
    </div>
  </form>
</template>

<script>
import { ClipLoader } from '@saeris/vue-spinners'

export default {
  name: 'ConfirmUser',
  components: {
    ClipLoader,
  },
  data() {
    return {
      email: '',
      loading: false,
    }
  },
  props: {
    emailValid: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    validateEmail() {
      this.$emit('emailTest', this.email)
    },
    async validateForm() {
      this.loading = true
      if (!this.emailValid) {
        this.$store.dispatch('app/setError', 'Please enter a valid email.')
      } else {
        const preparedEmail = this.email.toLowerCase().trim()
        await this.forceConfirmUser(preparedEmail)
      }
      this.loading = false
    },
    async forceConfirmUser(preparedEmail) {
      await this.$store.dispatch('admin/adminConfirmUser', preparedEmail)
    },
  },
}
</script>
